import { useRef, useCallback } from "react";
import { LOCAL_STORAGE_CHANGE_EVENT } from "../../../../constants/constants/events.js";
const isBrowser = () => {
  return typeof window !== "undefined" && typeof window.document !== "undefined";
};
const isLocalStorageChanged = (evt) => {
  return !!evt && typeof evt === "object" && "type" in evt && evt.type === LOCAL_STORAGE_CHANGE_EVENT;
};
const isFunction = (value) => typeof value === "function";
const tryParse = (value) => {
  try {
    return JSON.parse(value);
  } catch {
    return value;
  }
};
function useEffectEvent(callback) {
  const ref = useRef(callback);
  ref.current = callback;
  return useCallback((...args) => {
    const f = ref.current;
    return f(...args);
  }, []);
}
export {
  isBrowser,
  isFunction,
  isLocalStorageChanged,
  tryParse,
  useEffectEvent
};
//# sourceMappingURL=utils.js.map
